/**
 * Codigo do afiliado que trouxe o visitante (`?ref=codigo`).
 *
 * Fica guardado porque a pessoa raramente cria a conta na primeira visita. O
 * link mais recente vale, por ate 60 dias, e isso esta nos termos do programa.
 */
const CHAVE = "samev_indicacao";
const VALIDADE_MS = 60 * 24 * 60 * 60 * 1000;

export function guardarIndicacaoDaUrl(): void {
  const codigo = new URLSearchParams(window.location.search).get("ref")?.trim().toLowerCase();
  if (!codigo || !/^[a-z0-9]{4,32}$/.test(codigo)) return;
  try {
    localStorage.setItem(CHAVE, JSON.stringify({ codigo, em: Date.now() }));
  } catch {
    // Navegador sem armazenamento: o cadastro segue, so sem a indicacao.
  }
}

export function indicacaoGuardada(): string | null {
  try {
    const salvo = JSON.parse(localStorage.getItem(CHAVE) ?? "null") as {
      codigo: string;
      em: number;
    } | null;
    if (!salvo || Date.now() - salvo.em > VALIDADE_MS) return null;
    return salvo.codigo;
  } catch {
    return null;
  }
}

export function esquecerIndicacao(): void {
  try {
    localStorage.removeItem(CHAVE);
  } catch {
    // Nada a fazer.
  }
}
